import styled from "styled-components";
import CloseSVG from "../../assets/icons/close.svg";

export const Container = styled.div`
  padding: 17px;
  width: 100%;
  border-radius: 8px;
  margin-bottom: 20px;
  background-color: ${({ error }) =>
    error ? "var(--danger-form)" : "transparent"};
`;

export const Option = styled.div`
  position: relative;
  user-select: none;
  font-family: var(--font-heavy);
  height: fit-content;
  min-width: ${({ selected }) => (selected ? 335 : 36)}px;
  text-transform: uppercase;
  text-align: left;
  color: ${({ selected }) => (selected ? "var(--success)" : "var(--text)")};
  border-width: 1px;
  border-style: solid;
  border-color: ${({ selected }) =>
    selected ? "var(--success)" : "var(--text-light)"};

  border-radius: 8px;
  padding: ${({ condensed }) => (condensed ? 8 : 21)}px;
  margin-top: 12px;
  margin-right: 12px;
  cursor: pointer;
  transition: all 0.3s ease, padding 0.8s linear;

  :hover {
    border-color: var(${({ selected }) => (selected ? "--success" : "--text")});
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  ${Option} + ${Option} {
    /* margin-right: 18px; */
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const Col = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-family: var(--font-heavy);
  font-size: 12px;
  color: var(--black);
  text-transform: uppercase;
  text-align: left;
  letter-spacing: 0.02em;
  margin-bottom: 0;
  margin-top: 13px;
`;

export const Input = styled.input`
  font-family: var(--font-heavy);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: -0.01em;
  line-height: 16px;
  text-align: left;
  color: var(--purple);

  ::placeholder {
    color: var(--text-light);
  }
`;

export const CloseButton = styled.img.attrs({
  src: CloseSVG,
})`
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 12px;
`;
